(() => {
  if (window.__TAC_BUNDLE_CART_V1__) return;
  window.__TAC_BUNDLE_CART_V1__ = true;

  const PROP_ID = '_tac_bundle_id';
  const PROP_ROLE = '_tac_bundle_role';

  const IS_EN = String(document.documentElement.lang || '')
    .toLowerCase()
    .startsWith('en');

  const ROOT = () => (window.Shopify?.routes?.root || '/');

  let busy = false;
  let syncTimer = null;


  /* ==========================================================
     ESTILOS
     ========================================================== */

  function injectStyles() {
    if (document.getElementById('tac-bundle-cart-style')) return;

    const style = document.createElement('style');
    style.id = 'tac-bundle-cart-style';

    style.textContent = `
      /* Los add-ons NO se pueden eliminar */
      [data-tac-bundle-role="addon"] cart-remove-button,
      [data-tac-bundle-role="addon"] .cart-remove-button,
      [data-tac-bundle-role="addon"] .cart-items__remove {
        display: none !important;
      }

      /* Ni el álbum ni sus add-ons pueden cambiar cantidad */
      [data-tac-bundle-role="parent"] quantity-input,
      [data-tac-bundle-role="addon"] quantity-input,
      [data-tac-bundle-role="parent"] .quantity-selector,
      [data-tac-bundle-role="addon"] .quantity-selector {
        display: none !important;
      }

      /* Los add-ons se ven ligeramente subordinados */
      [data-tac-bundle-role="addon"] .cart-item__details,
      [data-tac-bundle-role="addon"] .cart-items__details {
        opacity: .88;
      }

      /* Etiqueta de bundle bloqueado */
      .tac-bundle-lock-note {
        display: inline-flex;
        align-items: center;
        width: fit-content;
        min-height: 2.8rem;
        padding: .45rem .8rem;
        border-radius: 999px;
        background: rgba(var(--color-foreground, 18, 18, 18), .06);
        font-size: 1.1rem;
        line-height: 1.2;
        letter-spacing: .02rem;
        white-space: nowrap;
      }

      /* Pantalla corta durante eliminación */
      #tac-bundle-busy {
        position: fixed;
        inset: 0;
        z-index: 2147483647;
        display: grid;
        place-items: center;
        background: rgba(255,255,255,.72);
        backdrop-filter: blur(3px);
      }

      #tac-bundle-busy > div {
        padding: 1.2rem 1.6rem;
        border-radius: 1.2rem;
        background: rgb(var(--color-background, 255,255,255));
        color: rgb(var(--color-foreground, 18,18,18));
        box-shadow: 0 .8rem 3rem rgba(0,0,0,.12);
        font-size: 1.4rem;
        font-weight: 600;
      }
    `;

    document.head.appendChild(style);
  }


  /* ==========================================================
     LEER CARRITO REAL DE SHOPIFY
     ========================================================== */

  async function getCart() {
    const res = await fetch(ROOT() + 'cart.js', {
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    });

    if (!res.ok) {
      throw new Error(`cart.js ${res.status}`);
    }

    return res.json();
  }


  /* ==========================================================
     LOCALIZAR EL LINE ITEM EN CART PAGE Y CART DRAWER
     ========================================================== */

  function candidateRows(index) {
    const rows = [];

    const pageExact =
      document.getElementById(`CartItem-${index}`);

    const drawerExact =
      document.getElementById(`CartDrawer-Item-${index}`);

    if (pageExact) rows.push(pageExact);
    if (drawerExact) rows.push(drawerExact);


    /* Fallback por si Dawn cambia ligeramente el markup */

    if (!pageExact) {
      const pageRows = Array.from(
        document.querySelectorAll(
          'cart-items .cart-item, #main-cart-items .cart-item'
        )
      );

      if (pageRows[index - 1]) {
        rows.push(pageRows[index - 1]);
      }
    }


    if (!drawerExact) {
      const drawerRows = Array.from(
        document.querySelectorAll(
          'cart-drawer-items .cart-item, #CartDrawer-CartItems .cart-item'
        )
      );

      if (drawerRows[index - 1]) {
        rows.push(drawerRows[index - 1]);
      }
    }


    return [...new Set(rows)];
  }


  /* ==========================================================
     DECORAR / BLOQUEAR UN LINE ITEM
     ========================================================== */

  function decorateRow(row, item) {
    const props = item?.properties || {};

    const bundleId =
      String(props[PROP_ID] || '').trim();

    const role =
      String(props[PROP_ROLE] || '')
        .trim()
        .toLowerCase();


    delete row.dataset.tacBundleId;
    delete row.dataset.tacBundleRole;


    if (
      !bundleId ||
      !['parent', 'addon'].includes(role)
    ) {
      row
        .querySelectorAll('.tac-bundle-lock-note')
        .forEach((el) => el.remove());

      return;
    }


    row.dataset.tacBundleId = bundleId;
    row.dataset.tacBundleRole = role;


    /*
      Aunque visualmente escondamos los controles,
      también los bloqueamos programáticamente.
    */

    row
      .querySelectorAll(
        'input.quantity__input, input[name="updates[]"], .quantity-selector input'
      )
      .forEach((input) => {
        input.value = '1';
        input.readOnly = true;
        input.disabled = true;
      });


    const host = row.querySelector(
      [
        '.cart-item__quantity-wrapper',
        '.cart-items__quantity-controls',
        '.cart-item__quantity',
        '.cart-items__quantity',
        '.cart-item__details',
        '.cart-items__details'
      ].join(', ')
    );


    if (
      host &&
      !host.querySelector('.tac-bundle-lock-note')
    ) {
      const note = document.createElement('span');

      note.className = 'tac-bundle-lock-note';

      note.textContent =
        role === 'addon'
          ? (
              IS_EN
                ? 'Included with your album'
                : 'Incluido en tu álbum'
            )
          : (
              IS_EN
                ? 'Configured album'
                : 'Álbum configurado'
            );

      host.prepend(note);
    }
  }


  /* ==========================================================
     SINCRONIZAR SHOPIFY CART → INTERFAZ
     ========================================================== */

  async function syncCartUI() {
    try {
      const cart = await getCart();

      (cart.items || []).forEach((item, idx) => {
        candidateRows(idx + 1)
          .forEach((row) => decorateRow(row, item));
      });

    } catch (error) {
      console.warn(
        '[TAC Bundle] No se pudo sincronizar la UI del carrito:',
        error
      );
    }
  }


  function scheduleSync() {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(
      syncCartUI,
      120
    );
  }


  /* ==========================================================
     OVERLAY
     ========================================================== */

  function showBusy() {
    if (document.getElementById('tac-bundle-busy')) {
      return;
    }

    const el = document.createElement('div');

    el.id = 'tac-bundle-busy';

    el.innerHTML = `
      <div>
        ${
          IS_EN
            ? 'Updating your album…'
            : 'Actualizando tu álbum…'
        }
      </div>
    `;

    document.body.appendChild(el);
  }


  function hideBusy() {
    document
      .getElementById('tac-bundle-busy')
      ?.remove();
  }


  /* ==========================================================
     ELIMINAR BUNDLE COMPLETO
     ========================================================== */

  async function removeBundle(bundleId) {
    if (busy || !bundleId) return;

    busy = true;

    showBusy();


    try {

      /*
        Volvemos a consultar el carrito inmediatamente antes
        de borrar para trabajar con los line item keys actuales.
      */

      const cart = await getCart();

      const updates = {};


      (cart.items || []).forEach((item) => {

        const itemBundleId =
          String(
            item?.properties?.[PROP_ID] || ''
          ).trim();


        if (
          itemBundleId === bundleId &&
          item.key
        ) {
          updates[item.key] = 0;
        }

      });


      if (!Object.keys(updates).length) {
        throw new Error(
          'Bundle not found in cart'
        );
      }


      /*
        Ejemplo:
        {
          "variant:key1": 0,
          "variant:key2": 0,
          "variant:key3": 0
        }

        Shopify elimina todos en una sola operación.
      */

      const res = await fetch(
        ROOT() + 'cart/update.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },

          body: JSON.stringify({
            updates
          })
        }
      );


      if (!res.ok) {
        const body = await res.text();

        throw new Error(
          `cart/update.js ${res.status}: ${body}`
        );
      }


      /*
        Reload intencional:
        garantiza que carrito,
        subtotal,
        descuentos,
        contador e interfaz Dawn
        queden 100% sincronizados.
      */

      window.location.reload();


    } catch (error) {

      console.error(
        '[TAC Bundle] Error al eliminar bundle:',
        error
      );

      hideBusy();

      busy = false;


      alert(
        IS_EN
          ? 'We could not update your album in the cart. Please try again.'
          : 'No pudimos actualizar tu álbum en el carrito. Inténtalo de nuevo.'
      );
    }
  }


  /* ==========================================================
     INTERCEPTAR BASURA Y CANTIDADES
     ========================================================== */

  document.addEventListener(
    'click',

    (event) => {

      const row =
        event.target.closest?.(
          '[data-tac-bundle-id][data-tac-bundle-role]'
        );

      if (!row) return;


      const role =
        row.dataset.tacBundleRole;

      const bundleId =
        row.dataset.tacBundleId;


      /*
        Detectamos basura tanto en Dawn cart page
        como en Dawn cart drawer.
      */

      const removeTrigger =
        event.target.closest?.(
          [
            'cart-remove-button',
            '.cart-remove-button',
            '.cart-items__remove',
            '[id^="Remove-"]',
            '[id^="CartDrawer-Remove-"]'
          ].join(', ')
        );


      if (removeTrigger) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        /*
          ADDON:
          jamás se elimina individualmente.
        */

        if (role === 'addon') {
          return;
        }


        /*
          PARENT:
          elimina TODO el bundle.
        */

        if (role === 'parent') {
          removeBundle(bundleId);
        }

        return;
      }


      /*
        También interceptamos cualquier intento
        de cambiar cantidad.
      */

      const quantityTrigger =
        event.target.closest?.(
          [
            'quantity-input',
            '.quantity__button',
            '.quantity-selector',
            '.quantity__input',
            'input[name="updates[]"]'
          ].join(', ')
        );


      if (
        quantityTrigger &&
        (
          role === 'parent' ||
          role === 'addon'
        )
      ) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();
      }

    },

    true
  );


  /* ==========================================================
     BLOQUEAR CAMBIO MANUAL DEL INPUT
     ========================================================== */

  document.addEventListener(
    'change',

    (event) => {

      const row =
        event.target.closest?.(
          '[data-tac-bundle-id][data-tac-bundle-role]'
        );

      if (!row) return;


      if (
        !event.target.matches?.(
          [
            'input[name="updates[]"]',
            '.quantity__input',
            '.quantity-selector input'
          ].join(', ')
        )
      ) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();

      event.target.value = '1';

    },

    true
  );


  /* ==========================================================
     INIT
     ========================================================== */

  injectStyles();


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      syncCartUI,
      { once: true }
    );

  } else {

    syncCartUI();

  }


  /*
    Dawn vuelve a renderizar partes del carrito mediante AJAX.
    Cada vez que lo haga, reaplicamos automáticamente
    las reglas del bundle.
  */

  const observer =
    new MutationObserver(
      scheduleSync
    );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();